import AuthenticatedRoute from 'eflex/util/authenticated-route';

export default class EvisionCameraCorrectFileNamingRoute extends AuthenticatedRoute {}
